import { render, staticRenderFns } from "./UnusedFilesViewer.vue?vue&type=template&id=76a950fd"
import script from "./UnusedFilesViewer.vue?vue&type=script&lang=js"
export * from "./UnusedFilesViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports